import { LineChart } from '@mui/x-charts/LineChart';
import MainCard from 'components/MainCard';
import { Typography, Chip, Box, Grid } from '@mui/material';
import { negativeSentimentColor, neutralSentimentColor, positiveSentimentColor, remainderSentimentColor } from '../../../src/utils/constant';



export default function SentimentAnalyticLineChart({ sentimentAnalyticsData }) {
    const positiveData = sentimentAnalyticsData?.result?.analyticsPositivePercent
    const negativeData = sentimentAnalyticsData?.result?.analyticsNegativePercent
    const neutralData = sentimentAnalyticsData?.result?.analyticsNeutralPercent
    const remainderData = sentimentAnalyticsData?.result?.analyticsRemainderPercent
    const xLabelsData = sentimentAnalyticsData?.result?.xLabels


    return (
        <>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid>
                    <Typography variant="h5">Sentiment Trend</Typography>
                </Grid>
            </Grid>
            <MainCard sx={{ mt: 2 }} content={false}>

                <Box sx={{ ml: `30px`, mr: `30px`, mt: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        Average sentiment over time
                    </Typography>
                </Box>
                {
                    sentimentAnalyticsData?.result && <LineChart sx={{ pr: 5, pb: 2 }}
                        xAxis={[{ scaleType: 'point', data: xLabelsData }]}
                        series={[
                            { id: 'positiveData', label: 'Positive', data: positiveData, color: positiveSentimentColor },
                            { id: 'neutralData', label: 'Neutral', data: neutralData, color: neutralSentimentColor },
                            { id: 'negativeData', label: 'Negative', data: negativeData, color: negativeSentimentColor },
                            { id: 'remainderData', label: 'Remainder', data: remainderData, color: remainderSentimentColor },
                        ]}
                        height={510}
                        slotProps={{
                            legend: {
                                direction: 'row',
                                position: { vertical: 'top', horizontal: 'right' },
                            },
                        }}
                    />
                }

            </MainCard>
        </>
    );
}